import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { ExpertEventNotificationRecord } from '@libs/shared/api';
import { ExpertEventNotificationWrapperComponent } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification-wrapper.component';
import { injectExpertEventNotificationService } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification.service';

@Component({
  selector:
    'app-expert-member-workout-feedback-comment-emoji-reaction-created-notification',
  standalone: true,
  imports: [CommonModule, ExpertEventNotificationWrapperComponent],
  template: `
    <app-expert-event-notification-wrapper
      class="cursor-pointer"
      (click)="onClick()"
      [notification]="notification"
      title="운동 피드백 댓글에 반응">
      <div class="text-secondary">
        {{ notification.notifier.nickname }}님이 운동 피드백 댓글에
        {{ notification.emojiReaction.code }}를 남겼어요.
      </div>
    </app-expert-event-notification-wrapper>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertMemberWorkoutFeedbackCommentEmojiReactionCreatedNotificationComponent {
  readonly vm = injectExpertEventNotificationService();
  readonly router = inject(Router);

  @Input({ required: true })
  notification: ExpertEventNotificationRecord;

  onClick() {
    this.vm.readExpertEventNotification(this.notification);
    this.router.navigate(
      [
        'expert-workspace',
        this.vm.currentExpertWorkspace$$().id,
        'expert-member',
        this.notification.expertMemberWorkoutFeedback.expertMemberId,
      ],
      {
        queryParams: {
          expertProgramWorkoutFeedbackId:
            this.notification.expertMemberWorkoutFeedback.id,
        },
        onSameUrlNavigation: 'reload',
      }
    );
  }
}
